import { config } from '~shared/config';
import { useConfirmation } from '~shared/ui/confirmation';
import { Screen, ScreenHeader } from '~shared/ui/screen';

import { Typography } from '@breezeventures/ui-kit/typography';
import { formatPhone } from '@breezeventures/utils/format-phone';
import { ConfirmOTP } from '@breezeventures/web-ph-client-auth/confirm-otp';
import { loginAtom } from '@breezeventures/web-ph-client-auth/model';
import { useSetAtom } from 'jotai';

import { useAuthApi } from '../../api';
import { trackAuthEvents } from '../../lib';

type OtpScreenProps = {
  onBack: () => void;
  phoneNumber: string;
};

export const OtpScreen = ({ onBack, phoneNumber }: OtpScreenProps) => {
  const authApi = useAuthApi();
  const login = useSetAtom(loginAtom);
  const { confirm } = useConfirmation();

  const onSuccess = () => {
    login(phoneNumber);
  };

  const checkIfShouldResend = async () => {
    try {
      await confirm({
        title: formatPhone(phoneNumber),
        description: 'Is mobile number correct?',
        confirmButtonText: 'Yes, resend code',
        cancelButtonText: 'No, change phone',
        onCancel: () => {
          onBack();
        },
        invertButtons: true,
      });
      return true;
    } catch (_error) {
      return false;
    }
  };

  return (
    <Screen header={<ScreenHeader onBack={onBack} />}>
      <div className="my-6 text-center">
        <Typography.Title size="s" className="mb-3">
          Confirm your mobile number
        </Typography.Title>
        <Typography.Text color="secondary">
          We sent a&nbsp;confirmation code to&nbsp;{formatPhone(phoneNumber)}
        </Typography.Text>
      </div>
      <ConfirmOTP
        trackEvent={(event) => trackAuthEvents(event, phoneNumber)}
        captchaApiKey={config.awsWafApiKey}
        phoneNumber={phoneNumber}
        api={authApi}
        onSuccess={onSuccess}
        submitButtonText="Next"
        checkIfShouldResend={checkIfShouldResend}
      />
    </Screen>
  );
};
